import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1e88e5' },
    secondary: { main: '#455a64' },
    background: { default: '#f7f9fc' },
    warning: { main: '#b7791f' },
  },
  components: {
    MuiButton: {
      defaultProps: { variant: 'text' },
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 8,
        },
      },
    },
  },
})

export default theme
